import { FC, ReactNode } from "react";

import { StyledStatusIndicator } from "./Styled";

export type StatusIndicatorType = "neutral" | "success" | "error" | "warning";

interface StatusIndicatorProps {
    type: StatusIndicatorType;
    children: ReactNode;
}

export const StatusIndicator: FC<StatusIndicatorProps> = ({
    type,
    children,
}) => {
    return (
        <StyledStatusIndicator $type={type}>{children}</StyledStatusIndicator>
    );
};
